import type { Router } from 'vue-router'

export const navigationErrorHandler: Parameters<Router['onError']>[0] = async (_error, _to, _from) => {

}
